const searchThreshold = window.theme.gtmSearchThreshold || 2;
const searchDelay = window.theme.gtmSearchDelayMS || 1200;
let viewSearchDataLayerDelay;
let viewItemListDataLayerDelay;
let clickSortOptionDataLayerDelay;
let TagalysCustomisations = {};

const viewSearchResultsDataLayerEvent = (helpers, productCardSelector) => {
  if (viewSearchDataLayerDelay) {
    clearTimeout(viewSearchDataLayerDelay);
  }
  const { getEnteredSearchQuery, getQuery, getAPIResponse, getProducts } = helpers;
  const count = getProducts().length;

  const viewSearchResultsActionEvent = () => {
    let query;
    if (getEnteredSearchQuery) {
      query = getEnteredSearchQuery();
    } else if (getQuery) {
      query = getQuery();
    } else {
      return;
    }

    if (query.length < searchThreshold) {
      return;
    }

    const promotionEvent = JSON.parse(
      localStorage.getItem("ga4-promotionView") || "{}"
    );
    const menuNavigationAction = JSON.parse(
      localStorage.getItem("ga4-navigationClick") || "{}"
    );
    const menuNavigationState =
      menuNavigationAction.menu_navigation_state || {};
      window.pushEvent({
        event: "search_results_action",
        menu_navigation_state: menuNavigationState,
        ecommerce: promotionEvent,
        interaction_type: "View Search Results",
        search_result_state: {
          search_type: "productSearch",
          result_count: count,
          search_term: query.toLowerCase(),
        },
      }, 'search_result_state');
  };

  const viewItemListEvent = (skusComingIntoView = []) => {
    const viewItemListSearchEvent = (itemList = []) => {
      if (!itemList.length) {
        return;
      }
      if (viewItemListDataLayerDelay) {
        clearTimeout(viewItemListDataLayerDelay);
      }

      viewItemListDataLayerDelay = setTimeout(() => {
        let promotionEvent = JSON.parse(
          localStorage.getItem("ga4-promotionView") || "{}"
        );
        const menuNavigationAction = JSON.parse(
          localStorage.getItem("ga4-navigationClick") || "{}"
        );
        const menuNavigationState =
          menuNavigationAction.menu_navigation_state || {};
        const isSearchSuggestions = productCardSelector.includes(
          "product-suggestions"
        );
        let visibleCount = window.viewItemListSearch.length;
        if (isSearchSuggestions && visibleCount > 5) {
          visibleCount = 5;
        }
        window.pushEvent({
          event: "view_item_list",
          menu_navigation_state: menuNavigationState,
          ecommerce: Object.assign(promotionEvent, {
            items: itemList,
            item_list_id: "search",
            item_list_name: "Search",
            item_list_type: "Search",
            item_total_count: count,
            item_visible_count: visibleCount,
          }),
        }, 'ecommerce');

        skusComingIntoView = [];
      }, 1000);
    };

    let productCards = document.querySelectorAll(productCardSelector);
    if (productCards.length) {
      productCards.forEach((card) => {
        let isVisibleNow = window.theme.isElementVisibleInViewport(card, true);
        card.setAttribute("data-visible-by-default", isVisibleNow);
        if (isVisibleNow) {
          skusComingIntoView.push(card.getAttribute("data-sku"));
        }

        const handleIntersection = (entries, observer) => {
          entries.forEach((entry) => {
            const visibleByDefault =
              card.getAttribute("data-visible-by-default") || false;
            isVisibleNow = window.theme.isElementVisibleInViewport(card, true);
            if (entry.intersectionRatio > 0) {
              observer.unobserve(entry.target);

              card.setAttribute("data-visible-in-viewport", isVisibleNow);
              if (isVisibleNow) {
                const allResults = getProducts();
                skusComingIntoView.push(card.getAttribute("data-sku"));
                const itemsInViewport = allResults.filter((item) =>
                  skusComingIntoView.includes(item.variants[0].sku)
                );
                window.viewItemListSearch = window.viewItemListSearch || [];
                const items = itemsInViewport.map((item) => {
                  const itemExists = window.viewItemListSearch.find(
                    (listItem) => listItem.item_id === item.variants[0].sku
                  );
                  const index = allResults.findIndex(
                    (result) => result.variants[0].sku === item.variants[0].sku
                  );
                  const productType = item.product_type;
                  const newItem = {
                    index: index + 1,
                    item_id: item.variants[0].sku,
                    item_name: item.title.replace(/["']/g, ""),
                    item_brand: "Lovisa",
                    item_category: productType,
                    item_list_id: "search",
                    item_list_name: "Search",
                    price: item.price,
                    quantity: 1,
                    visible_by_default: visibleByDefault,
                  };
                  if (!itemExists) {
                    window.viewItemListSearch.push(newItem);
                  }

                  if (card.getAttribute("data-sku") === item.variants[0].sku) {
                    card.addEventListener("click", () => {
                      // DATALAYER push data
                      window.dataLayer = window.dataLayer || [];
                      let promotionEvent = JSON.parse(
                        localStorage.getItem("ga4-promotionView") || "{}"
                      );
                      const menuNavigationAction = JSON.parse(
                        localStorage.getItem("ga4-navigationClick") || "{}"
                      );
                      const menuNavigationState =
                        menuNavigationAction.menu_navigation_state || {};
                      window.pushEvent({
                        event: "select_item",
                        item_list_id: "search",
                        item_list_name: "Search Results",
                        item_list_type: "Search",
                        menu_navigation_state: menuNavigationState,
                        ecommerce: Object.assign(promotionEvent, {
                          impressions: [newItem],
                        }),
                      }, 'ecommerce');

                      const itemDataJson = JSON.stringify({
                        itemListId: "search",
                        itemListName: "Search Results",
                        itemListType: "Search",
                        index: newItem.index,
                        itemCategory: newItem.item_category,
                      });
                      localStorage.setItem("ga-select-item", itemDataJson);

                      const itemListImpressions = JSON.parse(
                        localStorage.getItem("ga4-itemListImpressions") || "{}"
                      );
                      // clone newItem
                      const impressionItem = JSON.parse(
                        JSON.stringify(newItem)
                      );
                      impressionItem.price = newItem.price * 100;
                      itemListImpressions[newItem.item_id] = impressionItem;
                      localStorage.setItem(
                        "ga4-itemListImpressions",
                        JSON.stringify(itemListImpressions)
                      );
                    });
                  }
                  return newItem;
                });
                viewItemListSearchEvent(items);
              }
            }
          });
        };
        const observer = new IntersectionObserver(handleIntersection);
        observer.observe(card);
      });
    }
  };
  viewSearchDataLayerDelay = setTimeout(() => {
    viewSearchResultsActionEvent();
    viewItemListEvent();
  }, searchDelay);
};

const clickSortOptionDataLayerEvent = (helpers) => {
  if (clickSortOptionDataLayerDelay) {
    clearTimeout(clickSortOptionDataLayerDelay);
  }
  clickSortOptionDataLayerDelay = setTimeout(() => {
    const { label = "Default" } = helpers.getAppliedSortOption();
    const promotionEvent = JSON.parse(
      localStorage.getItem("ga4-promotionView") || "{}"
    );
    const menuNavigationAction = JSON.parse(
      localStorage.getItem("ga4-navigationClick") || "{}"
    );
    const menuNavigationState =
      menuNavigationAction.menu_navigation_state || {};
    window.pushEvent({
      event: "item_list_filter",
      menu_navigation_state: menuNavigationState,
      ecommerce: promotionEvent,
      interaction_type: "Sort",
      list_sort_order: label,
    });
  }, searchDelay);
};

const applyFilterDataLayerEvent = (props) => {
  const { filterId, filterItem, helpers } = props;
  const appliedFilters = helpers.getAppliedFilters(true) || [];
  const { label = "Default" } = helpers.getAppliedSortOption();
  const filters = {};
  appliedFilters.forEach(({ id, items }) => {
    let currentFilterId = id;
    if (currentFilterId.includes("_product_type")) {
      currentFilterId = "looking_for";
    }
    items.forEach((item) => {
      const name = item.label
        .toLowerCase()
        .split(" ")
        .map((word) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
      if (filters[currentFilterId] && filters[currentFilterId].length > 0) {
        filters[currentFilterId] += ` | ${name}`;
      } else {
        filters[currentFilterId] = name;
      }
    });
  });
  let appliedFilterId = filterId;
  if (appliedFilterId.includes("_product_type")) {
    appliedFilterId = "looking_for";
  }
  const filterName = filterItem.label
    .toLowerCase()
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
  if (filters[appliedFilterId] && filters[appliedFilterId].length > 0) {
    filters[appliedFilterId] += ` | ${filterName}`;
  } else {
    filters[appliedFilterId] = filterName;
  }

  const promotionEvent = JSON.parse(
    localStorage.getItem("ga4-promotionView") || "{}"
  );
  const menuNavigationAction = JSON.parse(
    localStorage.getItem("ga4-navigationClick") || "{}"
  );
  const menuNavigationState = menuNavigationAction.menu_navigation_state || {};
  window.pushEvent({
    event: "item_list_filter",
    menu_navigation_state: menuNavigationState,
    ecommerce: promotionEvent,
    interaction_type: "Add Filter",
    list_sort_order: label,
    list_filter_state: filters,
  }, 'list_filter_state');
};

const removeFilterDataLayerEvent = (props, filterId, filterItem) => {
  const { helpers } = props;
  const appliedFilters = helpers.getAppliedFilters(true) || [];

  let appliedFilterId = filterId;
  if (appliedFilterId.includes("_product_type")) {
    appliedFilterId = "looking_for";
  }

  let filterName = "";
  if (filterItem && filterItem.label) {
    filterName = `${filterItem.label[0].toUpperCase()}${filterItem.label
      .slice(1)
      .toLowerCase()}`;
  }

  const { label = "Default" } = helpers.getAppliedSortOption();

  const filters = {};
  appliedFilters.forEach(({ id, items }) => {
    let currentFilterId = id;
    if (currentFilterId.includes("_product_type")) {
      currentFilterId = "looking_for";
    }
    items.forEach((item) => {
      const name = item.name ? item.name
        .toLowerCase()
        .split(" ")
        .map((word) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ") : "";
      if (currentFilterId === appliedFilterId && name === filterName) {
        return;
      }
      if (currentFilterId === appliedFilterId && !filterName.length) {
        return;
      }

      if (filters[currentFilterId] && filters[currentFilterId].length > 0) {
        filters[currentFilterId] += ` | ${name}`;
      } else {
        filters[currentFilterId] = name;
      }
    });
  });

  const promotionEvent = JSON.parse(
    localStorage.getItem("ga4-promotionView") || "{}"
  );
  const menuNavigationAction = JSON.parse(
    localStorage.getItem("ga4-navigationClick") || "{}"
  );
  const menuNavigationState = menuNavigationAction.menu_navigation_state || {};
  window.pushEvent({
    event: "item_list_filter",
    menu_navigation_state: menuNavigationState,
    ecommerce: promotionEvent,
    interaction_type: "Remove Filter",
    list_sort_order: label,
    list_filter_state: filters,
  }, 'list_filter_state');
};

const clearAllFilterDataLayerEvent = (props) => {
  const { label = "Default" } = props.helpers.getAppliedSortOption();
  const promotionEvent = JSON.parse(
    localStorage.getItem("ga4-promotionView") || "{}"
  );
  const menuNavigationAction = JSON.parse(
    localStorage.getItem("ga4-navigationClick") || "{}"
  );
  const menuNavigationState = menuNavigationAction.menu_navigation_state || {};
  window.pushEvent({
    event: "item_list_filter",
    menu_navigation_state: menuNavigationState,
    ecommerce: promotionEvent,
    interaction_type: "Remove Filter",
    list_sort_order: label,
    list_filter_state: {},
  }, 'list_filter_state');
};

// eslint-disable-next-line no-unused-vars
const customTagalysActionEvents = function (helpers) {
  const handleOutsideClick = (evt) => {
    if (evt.target.parents(".collection-filters-block") !== false) {
      return;
    }

    const filters = document.querySelectorAll(".collection__filter.expanded, .collection__filter.is-expanded");
    if (filters && filters.length) {
      //filters.forEach((t) => t.classList.remove("is-expanded"));
    }
  };
  document.body.addEventListener("click", handleOutsideClick);
};

const forEachTagalysRecentSearchStore = (fn) => {
  Object.keys(window.localStorage).forEach((key) => {
    if (!key.startsWith("tagalysRecentSearches:")) {
      return;
    }
    try {
      const stored = JSON.parse(window.localStorage.getItem(key));
      if (!Array.isArray(stored?.value?.queries)) {
        return;
      }
      fn(key, stored);
    } catch {
      // ignore
    }
  });
};

const normalizeTagalysSearchTerm = (value) => String(value ?? "").toLowerCase().trim();

const REMOVED_TAGALYS_SEARCHES_KEY = "tagalysRemovedSearches";

const getRemovedTagalysSearches = () => {
  try {
    const removed = JSON.parse(window.localStorage.getItem(REMOVED_TAGALYS_SEARCHES_KEY));
    return Array.isArray(removed) ? removed : [];
  } catch {
    return [];
  }
};

const setRemovedTagalysSearches = (terms) => {
  try {
    window.localStorage.setItem(REMOVED_TAGALYS_SEARCHES_KEY, JSON.stringify(terms.slice(0, 20)));
  } catch {
    // ignore
  }
};

// Drop removed terms and the duplicates the SDK's broken de-dupe leaves
// behind (it re-encodes before comparing, so multi-word terms never match
// and every search results page load appends another copy).
const cleanTagalysRecentSearches = () => {
  const removed = getRemovedTagalysSearches();
  forEachTagalysRecentSearchStore((key, stored) => {
    const seen = new Set();
    const queries = [];
    stored.value.queries
      .slice()
      .reverse() // newest entries are appended last — keep those
      .forEach((item) => {
        const term = normalizeTagalysSearchTerm(item.query);
        if (removed.includes(term) || seen.has(term)) {
          return;
        }
        seen.add(term);
        queries.unshift(item);
      });
    if (queries.length !== stored.value.queries.length) {
      stored.value.queries = queries;
      window.localStorage.setItem(key, JSON.stringify(stored));
    }
  });
};

// Tagalys removeRecentSearch can't match terms with spaces/special chars, so
// clear the entry ourselves and remember it: search results pages re-record
// their query on every load, which would otherwise resurrect removed terms.
const removeTagalysRecentSearch = (event, helpers, query) => {
  // the re-render detaches the clicked button, so if this click bubbles to
  // the SDK's outside-click handler it hides the whole popover
  event.stopPropagation();
  const term = normalizeTagalysSearchTerm(query);
  const removed = getRemovedTagalysSearches();
  if (!removed.includes(term)) {
    setRemovedTagalysSearches([term, ...removed]);
  }
  cleanTagalysRecentSearches();
  helpers.removeRecentSearch(`query=${encodeURIComponent(query)}`);
};

// Searching a removed term again (a real navigation to its results page, not
// a reload) makes it part of the history again.
const restoreTagalysSearchOnNewSearch = () => {
  if (window.theme?.template?.name !== "search") {
    return;
  }
  const nav = window.performance?.getEntriesByType?.("navigation")[0];
  if (nav && nav.type !== "navigate") {
    return;
  }
  const term = normalizeTagalysSearchTerm(new URLSearchParams(window.location.search).get("query"));
  const removed = getRemovedTagalysSearches();
  if (!term || !removed.includes(term)) {
    return;
  }
  setRemovedTagalysSearches(removed.filter((item) => item !== term));
};

restoreTagalysSearchOnNewSearch();
cleanTagalysRecentSearches();
// capture phase so it runs before the widget reads the store on focus
document.addEventListener("focus", cleanTagalysRecentSearches, true);

// The desktop search icon navigates straight to the rotating word's link, so
// no search page ever loads and Tagalys records nothing — record the shown
// term ourselves before the navigation (mobile submits a real search instead).
const recordTagalysRecentSearch = (query) => {
  const term = String(query ?? "").trim();
  const shopId = window.theme?.permanent_domain;
  const countryCode = window.theme?.tagalysCountryCode;
  if (!term || !shopId || !countryCode) {
    return;
  }
  const normalized = normalizeTagalysSearchTerm(term);
  setRemovedTagalysSearches(getRemovedTagalysSearches().filter((item) => item !== normalized));
  const key = `tagalysRecentSearches:${shopId}:${countryCode}`;
  try {
    const stored = JSON.parse(window.localStorage.getItem(key)) ?? { value: { queries: [] } };
    if (!Array.isArray(stored?.value?.queries)) {
      return;
    }
    stored.value.queries = stored.value.queries
      .filter((item) => normalizeTagalysSearchTerm(item.query) !== normalized)
      .concat([{ query: term, expiry: Date.now() + 36e5 }]);
    window.localStorage.setItem(key, JSON.stringify(stored));
  } catch {
    // ignore
  }
};

document.addEventListener("click", (event) => {
  const goLink = event.target?.closest?.("[data-shd-search-go]:not([data-no-link])");
  if (!goLink) {
    return;
  }
  const pill = goLink.closest("[data-shd-search]");
  const word = pill?.querySelector("[data-ph-word].is-active") ?? pill?.querySelector("[data-ph-word]");
  recordTagalysRecentSearch(word?.getAttribute("data-label") ?? word?.textContent);
});

/**
 * Tagalys search component configuration
 */
TagalysCustomisations.initTagalysSearchSuggestions = function () {
  const isSearchPage =
    window.theme.template.name === "search" ||
    window.theme.template.name === "404";
  const searchElementsFrms = [".search__input"];

  window.Tagalys.UIWidgets.SearchSuggestions.init(searchElementsFrms, {
    searchResultsURL: "/search",
    templates: {
      widget: {
        labels: getTagalysLabels('searchResults'),
        options: {
          sections: {
            products: {
              count: window.innerWidth < theme.settings.grid_medium ? 24 : 6,
            },
            collections: {
              count: 4,
            },
            pages: {
              count: 2,
            },
          },
          hierarchySeparator: "➜",
          position: "bottom",
          minimumCharactersToShowSuggestions: 2,
          maxRecentSearchesCount: 5,
          maxTotalSearchesCount: 10,
          alignToSelector: isSearchPage ? false : "#search--app",
          includeTagalysCSS: false,
          inheritAlignmentElementWidth: true,
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var width = helpers.getTargetNodeWidth();
          width = isSearchPage ? width + 40 : width;
          var style = props.inheritAlignmentElementWidth
            ? { width: width }
            : {};

          return html`
            <div
              ref=${props.tagalysSearchSuggestionsPopoverRef}
              style=${style}
              class="search-suggestions search__results"
            >
              <${args.templates.hint} />
              ${
                helpers.exceedsMinimumCharactersToShowSuggestions()
                  ? html`
                    <${args.templates.typeSuggestions} />
                  `
                  : html`
                    <div class="popular-view">
                      Trending Searches
                    </div>
                    <${args.templates.clickSuggestions} />
                  `
              }
            </div>
          `;
        },
      },
      typeSuggestions: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var textSuggestions = helpers.getTextSuggestions();

          const multibuyCollectionHandles = (window.theme.multibuy_offer_discounts || []).map((item)=>( item.collectionHandle ))

          textSuggestions = textSuggestions.map((item)=>{
            if( item.id !== "collections" ) return item
            return {
              ...item,
              items: item.items.map((collection)=>{
                if ( multibuyCollectionHandles.includes(collection.handle) ) {
                  const multibuyCollection = (window.theme.multibuy_offer_discounts || []).find((item)=>( item.collectionHandle === collection.handle ))
                  if( multibuyCollection ) {
                    const multibuyCollectionTitle = multibuyCollection.description || multibuyCollection.title || collection.title
                    return {
                      ...collection,
                      title: multibuyCollectionTitle
                    }
                  }
                }
                return collection
              })
            }
          })

          var classes = ["type-suggestions"];
          if (helpers.hasTextSearchSuggestions() > 0) {
            classes.push("product-and-text-suggestions");
          } else {
            classes.push(
              "product-suggestions search__results-products ais-index"
            );
          }
          var className = classes.join(" ");

          return html`
            <div class=${className}>
             <div class="mobi-hint">${html`<${args.templates.hint} />`}</div>
              ${
                helpers.hasTextSearchSuggestions()
                  ? html`
                    <ul class="text-suggestions">
                      ${textSuggestions.map(
                        (textSuggestionSection) =>
                          html`
                            <${args.templates.textSuggestionSection} textSuggestionSection=${textSuggestionSection} />
                          `
                      )}
                    </ul>
                  `
                  : ""
              }
              <${args.templates.products} class="product-suggestions" />
            </div>
          `;
        },
      },
      hint: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          // eslint-disable-next-line no-unused-vars
          var widgetOptions = helpers.getTemplateOptions("widget");
          var getLabel = () => {
            if (helpers.exceedsMinimumCharactersToShowSuggestions()) {
              return "View All Results";
            }
            return "";
          };

          return html`
            <div class="hint">
              <a
                class="search-results-link"
                href=${helpers.getURLEncodedQueryString({
                  query: helpers.getEnteredSearchQuery(),
                })}
              >
                ${getLabel()}
              </a>
              ${
                getLabel()
                  ? html`
                    <button onClick=${helpers.hideSearchSuggestionsPopover}>
                      ${window.tagalysIcon.closeIcon(html)}
                    </button>
                  `
                  : ""
              }
            </div>
          `;
        },
      },
      recentSearchItem: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var enteredSearchQuery = helpers.getEnteredSearchQuery();

          return html`
            <li class="click-suggestion recent-search-item">
              <a class="search-results-link" href=${helpers.getLink(
                props.recentSearch.query
              )}>
                <${args.templates.recentSearchIcon} />
                <${args.templates.highlighter}
                  label=${props.recentSearch.query}
                  highlight=${enteredSearchQuery}
                />
              </a>
              <button
                aria-label=${args.labels.searchResults.recentSearch.removeRecentSearch}
                onClick=${(event) =>
                  removeTagalysRecentSearch(event, helpers, props.recentSearch.query)}
              >
                ${window.tagalysIcon.closeIcon(html)}
              </button>
            </li>
          `;
        },
      },
      products: {
        render: function (html, args) {
          var props = args.props;
          var products = props.helpers.getProducts();
          viewSearchResultsDataLayerEvent(
            props.helpers,
            ".product-suggestions .search-result"
          );
          if (!products.length) {
            return html``;
          }

          return html`
            <div class=${`products search__results-grid search__results-products-grid ${props.className}`}>
              ${products.slice(0, 10).map((product, index) => {
                return (product.images.length > 0)
                ?
                  html`
                    <${args.templates.product} key=${index} product=${product} />
                  `
                : '';
              })}
            </div>
          `;
        },
      },
      product: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var product = props.product;
          // console.log('price',product);
          var enteredSearchQuery = helpers.getEnteredSearchQuery();
          var productOptions = helpers.getTemplateOptions("product");
          var productLink = productOptions.productPageUrl(product);
          const {price, compareAtPrice} = window.renderHelpers.getPrice(product)

          return html`
            <div class="product search-result" data-sku="${
              product.variants[0].sku
            }">
              <a class="product-link" title="${
                product.title
              }" href=${productLink}>
                <span class="product-image-container">
                  ${window.renderHelpers.productCard.wishlistButton(html, args)}

                  <img class="product-image" src=${
                    product.featured_image?.src
                  } alt=${product.title} />
                </span>
                <div class="product-details">
                  <span class="product-name search-result__title">
                    <${args.templates.highlighter} label=${product.title} highlight=${enteredSearchQuery} />
                  </span>
                  <div class="product-card__price product-card--flex">
                  ${
                    helpers.isStorefrontAPICallPending()
                      ? html`
                        <span class="skeleton-box"></span>
                      `
                      : html`
                        <span class=${`product-prices ${
                          helpers.isProductOnSale(
                            compareAtPrice,
                            price
                          )
                            ? " discounted"
                            : " full-price"
                        }`}>
                          
                           ${
                             compareAtPrice === null
                               ? html`
                              <span
                                class="product-price-regular"
                                 dangerouslySetInnerHTML=${{
                                   __html:
                                     helpers.formatCurrency(
                                       price
                                     ),
                                 }} 
                                />
              `
                               : html`  <span
                                class="product-price-regular"
                                 dangerouslySetInnerHTML=${{
                                   __html:
                                     helpers.formatCurrency(
                                       compareAtPrice
                                     ),
                                 }}
                                />`
                           }
                           ${
                             helpers.isProductOnSale(
                               compareAtPrice,
                               price
                             )
                               ? html`
                              <span
                                class="sale-price-text-color product-price-discounted"
                                dangerouslySetInnerHTML=${{
                                  __html:
                                    helpers.formatCurrency(price),
                                }}
                                
                                />
                              `
                               : ""
                           }
                         
                        </span>
                      `
                  } ${
                      helpers.isProductOnSale(compareAtPrice, price)
                      ? html`
                                        <span class="product-per-off ${
                                          window.theme.showPerOffMobile
                                            ? "show-per-off-mobile"
                                            : ""
                                        }${
                      window.theme.showPerOffDesktop
                        ? " show-per-off-desktop"
                        : ""
                      }">
                    (-${Math.round(
                      ((compareAtPrice - price) * 100) /
                        compareAtPrice
                    )}%)
                  </span>
                `
: ""
}
 </div> 
                </div>
              </a>
            </div>
          `;
        },
      },
      popularSearchIcon: {
        render: function (html, args) {
          return window.tagalysIcon.popularSearch(html);
        },
      }
    },
    callbacks: {
      // eslint-disable-next-line no-unused-vars
      beforeAPICall: function (requestParams, helpers) {
        const bodyElement = document.querySelector("body");
        const is404Page = bodyElement.classList.contains("template-404");
        const elementToObserve = document.querySelector(
          ".tagalys-search-suggestions"
        );

        const searchWrapper = document.querySelector("#search--app");
        if( searchWrapper && elementToObserve ) searchWrapper.appendChild(elementToObserve)

        let style = document.querySelector("style#tagalys-custom-style");
        if (!style) {
          style = document.createElement("style");
          style.id = "tagalys-custom-style";
          document.head.appendChild(style);
        }

        const observer = new MutationObserver(() => {
          if (elementToObserve.hasChildNodes()) {
            elementToObserve.classList.remove("tagalys-namespace");
            elementToObserve.id = "tagalys--namespace";
            /*
            setTimeout(function () {
              const headerElement = document.querySelector(
                "#shopify-section-header"
              );
              const headerElementHeight = headerElement
                ? headerElement.getBoundingClientRect().height
                : 0;
              const categorySubnavElement = document.querySelector(
                "#shopify-section-category-subnav"
              );
              const categorySubnavElementHeight = categorySubnavElement
                ? categorySubnavElement.getBoundingClientRect().height
                : 0;
              const searchIsVisibleElement =
                document.querySelector(".search.is-visible");
              const searchIsVisibleElementHeight = searchIsVisibleElement
                ? searchIsVisibleElement.getBoundingClientRect().height
                : 0;
              const headerHeight =
                headerElementHeight +
                categorySubnavElementHeight +
                searchIsVisibleElementHeight;

              style.textContent = `
                @media only screen and (min-width: 768px) {
                  .search-suggestions {
                  top: ${parseInt(headerHeight) - 2}px!important;
                  }
                }`;
            }, 50);
            */

            if (is404Page) {
              bodyElement.classList.add("tagalys-404-page");
            }
          } else {
            if (is404Page) {
              // eslint-disable-line
              bodyElement.classList.remove("tagalys-404-page");
            }
          }
        });
        observer.observe(elementToObserve, {
          subtree: true,
          childList: true,
        });
        return requestParams;
      },
      onSuccessfulAPICall: function (response, helpers) {
        setTimeout(function () {
          if (typeof ReloadSmartWishlist === 'function') {
            ReloadSmartWishlist();
          }
        }, 500);
        return response;
      },
    },
  });
};

/**
 * Tagalys search result page configuration
 */
TagalysCustomisations.initTagalysSearchResults = function () {
  const noResultWidgetObj = window.theme.tagalysNoResultsWidgetId
    ? {
      recommendationId: window.theme.tagalysNoResultsWidgetId,
        options: {
          templates: {
            widget: {
              labels: getTagalysLabels('noResults'),
              options: {
                includeTagalysCSS: false,
                displayFormat: "grid",
                perPage: window.theme.tagalysNoSearchResultCount,
              },
              render: function (html, args) {
                var props = args.props;
                var helpers = props.helpers;
                var products = helpers.getProducts();
                if (props.loading !== false) {
                  return html``;
                }

                if (products.length === 0) {
                  return html``;
                }

                return html`
                  <div class="widget">
                    <${args.templates.header} />
                    <div class="widget-body">
                      <div class="collection__products medium-up--one-whole">
                        <div role="list" class="grid grid--flex display--grid">
                          <${args.templates.productList} />
                        </div>
                        <${args.templates.noResultCTA} />
                      </div>
                    </div>
                    <${args.templates.footer} />
                  </div>
                `;
              },
            },
            header: {
              render: function (html, args) {
                var props = args.props; // eslint-disable-line no-unused-vars
                return html`
                  <div class="widget-header">
                    <strong class="widget-heading">
                      ${args.labels.noResults.heading}
                    </strong>
                  </div>
                `;
              },
            },
            products: {
              render: function (html, args) {
                var props = args.props;
                var helpers = props.helpers;
                var products = helpers.getProducts();
                viewSearchResultsDataLayerEvent(
                  helpers,
                  ".search-results .product-card"
                );

                return html`
                  ${products.map(
                    (product, index) =>
                      (product.images.length > 0)
                      ? html `
                          <${args.templates.product} key=${index} product=${product} />
                        `
                      : ''
                  )}
                `;
              },
              callbacks: {
                // eslint-disable-next-line no-unused-vars
                afterInitialRender: function (helpers) {
                  setTimeout(function () {
                    window.renderHelpers.updateProductCards(".product-card");
                  }, 2000);
                },
              },
            },
            noResultCTA: {
              // Custom template to render No Result CTA btn
              render: function (html, args) {
                var product = args.props.product; // eslint-disable-line no-unused-vars
                if (!window.theme.tagalysNoResultsCTA_Text) {
                  return html``;
                }

                return html`
                  <div class=" tagalys-no-result-cta">
                    <a href="${window.theme.tagalysNoResultsCTA_URL}" class="btn--text">
                      ${window.theme.tagalysNoResultsCTA_Text}
                    </a>
                  </div>
                `;
              },
            },
            productObj: {
              // Custom template to render variants
              render: function (html, args) {
                return window.renderHelpers.productObj(html, args)
              },
            },
            variantSelect: {
              render: function (html, args) {
                return window.renderHelpers.variantSelect(html, args);
              },
            },
            variantOption: {
              render: function (html, args) {
                var product = args.props.product;
                var variants = product.variants;
                return html`
                    <div class="product-card__variant-picker product-card__variant-picker--with-options">
                      ${window.renderHelpers.variantOption.header(html, args)}
                      <div role="list" class="product-card__variants">
                        ${window.renderHelpers.variantOption.variantList(html, args)}
                        <div role="listitem" class="product-card__variant-container">
                          <button
                            type="button"
                            class="close-show-variants"
                            aria-label="${args.labels.products.closeVariants}"
                          >
                            ${window.tagalysIcon.closeShowVariants(html)}
                          </button>
                        </div>
                      </div>
                      <div role="list" class="product-card__mobile-variants">
                        ${window.renderHelpers.variantOption.variantListMobile(html, args)}
                      </div>
                    </div>
                  `;
              },
            },
            addToCartForm: {
              render: function (html, args) {
                var product = args.props.product;
                var variants = product.variants;
                var isOnlyInStore = false;
                var tags = product.tags;
                if (tags.length) {
                  tags.forEach(function (tag) {
                    if (tag === "in-store") {
                      isOnlyInStore = true;
                    }
                  });
                }

                return html`                
                  <form action="${
                    window.plp_vars.cart_add_url
                  }" method="post" enctype="multipart/form-data" class="form">
                    <input type="hidden" name="quantity" value="1" />
                    <${args.templates.variantSelect} product=${product} />
                    <${args.templates.variantOption} product=${product} />
                    ${
                      variants.length > 1
                        ? html`
                          <button class="product__add--show-variants" type="button" aria-label="${args.labels.products.quickAdd}">
                            ${window.tagalysIcon.cart(html)}
                          </button>
                          <button
                            type="button"
                            class="product__add--mobile product__add--show-variants"
                            aria-label="${args.labels.products.quickAdd}"
                          >
                            ${window.tagalysIcon.cart(html)}
                          </button>
                        `
                        : html`
                          <button
                            class="product__add"
                            type="submit"
                            name="add"
                            data-add-to-cart=""
                            aria-label="${args.labels.products.quickAdd}"
                          >
                          ${window.tagalysIcon.cart(html)}
                          </button>
                          <button
                            class="product__add--mobile"
                            type="submit"
                            name="add"
                            data-add-to-cart=""
                            aria-label="${args.labels.products.quickAdd}"
                          >
                            ${window.tagalysIcon.shoppingBag(html)}
                            ${window.tagalysIcon.checkmark(html)}
                          </button>
                        `
                    }
                  </form>
                `;
              },
            },
            product: {
              render: function (html, args) {
                var props = args.props;
                var helpers = props.helpers;
                var product = props.product;
                var fomoBadgeStyle = "";
                var promo_text = "";
                var promo_style = "";
                var promo_link = "";
                var productOptions = helpers.getTemplateOptions("product");
                var productLink = productOptions.productPageUrl(product);
                var navigateToProductDetailPage = (event) => {
                  try {
                    sessionStorage.setItem("tagalys_product_card_clicked", product.id);
                  } catch (e) {
                    console.log('Failed to save breadcrumb map to sessionStorage', e);
                  }
                  helpers.navigateToProductDetailPage(event, product);
                }
                const {price, compareAtPrice} = window.renderHelpers.getPrice(product)

                let badge = "", badgeStyles = "";
                let {isOnlyInStore, isOnlyInStoreClass, offer, offerProperty} = window.renderHelpers.getTags(product.tags)

                if (!badge) {
                  var collections = product.collections;
                  var collectionsMetaObject = window.theme.collectionMetaobjects;
                  var tempbadge = false;
                  // Quickview two badge
                  var quickviewBadgeCounter = 0;
                  var quickviewBadgeHtml = "";

                  for (var i = 0; i < collectionsMetaObject.length; i++) {
                    let badgeCollections = collectionsMetaObject[i].collections || [];
                    if(badgeCollections.length > 0){
                      for (var j = 0; j < collections.length; j++) {
                        let matchFound = badgeCollections.some(bc => String(bc.id) === String(collections[j].id));
                        if (matchFound) {
                          var quickviewbadgestyle = "";
                          var quickviewbadgeClass = "";
                          quickviewbadgestyle = `background-color:  ${collectionsMetaObject[i].badge_background_color}`;
                          quickviewbadgestyle = `${quickviewbadgestyle}; color:  ${collectionsMetaObject[i].badge_text_color};`;
                          if (collectionsMetaObject[i].badge_border_color) {
                            quickviewbadgestyle = `${quickviewbadgestyle}; border-color:${collectionsMetaObject[i].badge_border_color};`;
                          }
                          if (collectionsMetaObject[i].opacity) {
                            quickviewbadgestyle = `${quickviewbadgestyle}; opacity:${collectionsMetaObject[i].opacity};`;
                          }
                          if (collectionsMetaObject[i].fomo_style == true) {
                            quickviewbadgeClass = "fomo-badge";
                          } else if (
                            collectionsMetaObject[i].default_style == true
                          ) {
                            quickviewbadgeClass = "default-badge";
                          }
                          quickviewBadgeHtml = html`${quickviewBadgeHtml}<div data-product-card-badge="9716480573767" data-badgestr="${collectionsMetaObject[i].badge_text}" class="product-card__badge ${quickviewbadgeClass}" style="${quickviewbadgestyle}">${collectionsMetaObject[i].badge_text}</div>`;
                          quickviewBadgeCounter++;
                          if (quickviewBadgeCounter >= 2) {
                            break;
                          }
                        }
                      }
                    }
                  }
                  for (var i = 0; i < collectionsMetaObject.length; i++) {
                    for (var j = 0; j < collections.length; j++) {
                      if (
                        collections[j].title ==
                        collectionsMetaObject[i].collection_name
                      ) {
                        badge = collectionsMetaObject[i].badge_text;
                        badgeStyles = `background-color:  ${collectionsMetaObject[i].badge_background_color}`;
                        badgeStyles = `${badgeStyles}; color:  ${collectionsMetaObject[i].badge_text_color};`;
                        if (collectionsMetaObject[i].badge_border_color) {
                          badgeStyles = `${badgeStyles}; border-color:${collectionsMetaObject[i].badge_border_color};`;
                        }
                        if (collectionsMetaObject[i].opacity) {
                          badgeStyles = `${badgeStyles}; opacity:${collectionsMetaObject[i].opacity};`;
                        }
                        if (collectionsMetaObject[i].fomo_style == true) {
                          fomoBadgeStyle = "fomo-badge";
                        } else if (
                          collectionsMetaObject[i].default_style == true
                        ) {
                          fomoBadgeStyle = "default-badge";
                        }
                        tempbadge = true;
                        break;
                      }
                    }
                    if (tempbadge) {
                      break;
                    }
                  }
                }

                var collections = product.collections;
                var promo_callout_metaobject =
                window.theme.promo_callout_metaobject;
                var temppromo = false;
                for (var i = 0; i < promo_callout_metaobject.length; i++) {
                  for (var j = 0; j < collections.length; j++) {
                    if (collections[j].id == promo_callout_metaobject[i].id) {
                      promo_text = promo_callout_metaobject[i].promo_text;
                      // console.log("promo_text", promo_text);
                      promo_style = `color:  ${promo_callout_metaobject[i].text_colour};`;
                      promo_link = `/collections/${collections[j].handle}`;
                      temppromo = true;
                      break;
                    }
                  }
                  if (temppromo) {
                    break;
                  }
                }

                // Multibuy offer badges
                var multibuy_offer_discounts = window.theme.multibuy_offer_discounts || [];
                const currentPageHandle = window.theme && window.theme.currentPageHandle
                  ? String(window.theme.currentPageHandle)
                  : (window.location.pathname.includes('/collections/')
                    ? window.location.pathname.split('/collections/')[1].split('/')[0].split('?')[0]
                    : '');

                for (var i = 0; i < multibuy_offer_discounts.length; i++) {
                  const offer = multibuy_offer_discounts[i];
                  const discount_type = offer.discount_type;
                  const discount_key = offer.discount_key || '';
                  const collection_handle = offer.collectionHandle || '';
                  const collectionTitle = offer.collectionTitle || '';
                  if (offer.active === false || offer.active === 'false') continue;
                  if (!discount_key && !collection_handle) continue;

                  let isMatch = false;

                  if (discount_type === "collection" || !discount_type) {
                    if (collection_handle && currentPageHandle && String(currentPageHandle) === String(collection_handle)) {
                      isMatch = true;
                    }
                    if (!isMatch && discount_key && currentPageHandle && String(currentPageHandle) === String(discount_key)) {
                      isMatch = true;
                    }
                    if (!isMatch && product.collections && Array.isArray(product.collections)) {
                      isMatch = product.collections.some(function(c) {
                        if (!c) return false;
                        const cHandle = typeof c === 'object' && c !== null ? c.handle : (typeof c === 'string' ? c : null);
                        const cTitle = typeof c === 'object' && c !== null ? c.title : (typeof c === 'string' ? c : null);
                        const cId = typeof c === 'object' && c !== null ? c.id : (typeof c === 'number' || typeof c === 'string' ? c : null);

                        if (collection_handle && cHandle && String(cHandle) === String(collection_handle)) return true;
                        if (discount_key && ((cHandle && String(cHandle) === String(discount_key)) || (cTitle && String(cTitle) === String(discount_key)))) return true;
                        if (collectionTitle && cTitle && String(cTitle) === String(collectionTitle)) return true;
                        if (offer.id && cId && String(cId) === String(offer.id)) return true;
                        return false;
                      });
                    }
                    if (!isMatch && product.tags && Array.isArray(product.tags)) {
                      if (collection_handle && product.tags.includes(collection_handle)) isMatch = true;
                      if (!isMatch && discount_key && product.tags.includes(discount_key)) isMatch = true;
                    }
                  }

                  if (!isMatch && (discount_type === "tag" || !discount_type)) {
                    if (product.tags && Array.isArray(product.tags)) {
                      if (discount_key && product.tags.includes(discount_key)) isMatch = true;
                      if (!isMatch && collection_handle && product.tags.includes(collection_handle)) isMatch = true;
                    }
                  }

                  if (isMatch) {
                    promo_text = offer.description || offer.title || "";
                    promo_link = offer.collectionUrl || (collection_handle ? `/collections/${collection_handle}` : (discount_key ? `/collections/all/tagged/${discount_key}` : '#'));
                    if (offer.color) {
                      promo_style = `color: ${offer.color};`;
                    }
                    temppromo = true;
                    promo_format_only = true;
                    break;
                  }
                }

                return html`
                  <div class="grid__item medium-down--one-half large-up--one-whole"  product-card-wrapper>
                    <div class="product-card product-card--quick" data-offer="${offerProperty}" data-sku="${
                      product.variants[0].sku
                    }">
                      ${window.renderHelpers.productCard.wishlistButton(html, args)}
                      <div class="product-card__image">
                        <div class="product-card__image--wrapper" onClick=${navigateToProductDetailPage}>
                          <a href="${productLink}" title="${product.title}">
                            ${window.renderHelpers.productCard.images(html, args)}
                          </a>
                        </div>
                        ${window.renderHelpers.productCard.actions(html, args, isOnlyInStoreClass)}
                      </div>
                       ${
                         badge != ""
                           ? html`<div style="${badgeStyles}" class="product-card__badge ${fomoBadgeStyle}" data-product-card-badge="${product.id}" data-badgestr="${badge}">${badge}</div><div class="quickviewBadges" style="display:none;">${quickviewBadgeHtml}</div>`
                           : ""
                       }
                      <div class="product-card__info">
                        <div class="product-card__details">
                          <div class="product-card__text">
                          ${
                             promo_text != ""
                               ? html`<a href="${promo_link}" style="${promo_style || ''}" class="promo_callout" data-text="${promo_text.replace(/\"|\'/g, '').replace(/\s/g, '')}" data-currency="${window.theme.currentCurrency}">
                                   ${window.tagalysIcon.plpPromoImage(html)}
                                   ${window.tagalysIcon.quickviewPromoImage(html)}
                                   <span>${theme.CurrencySwitcher ? theme.CurrencySwitcher.getCurrencyHTML(promo_text, html, promo_format_only) : promo_text}</span>
                                   </a>`
                               : ""
                           }
                            <h4 class="product-card__title"  onClick=${navigateToProductDetailPage}>
                              <a href="${productLink}">
                                <span>${product.title}</span>
                              </a>
                            </h4>
                            <div class="product-card__price product-card--flex"  onClick=${navigateToProductDetailPage}>
                                ${
                                  helpers.isStorefrontAPICallPending()
                                    ? html`
                                      <span class="skeleton-box"></span>
                                    `
                                    : html`
                                      <span class=${`product-prices ${
                                        helpers.isProductOnSale(
                                          compareAtPrice,
                                          price
                                        )
                                          ? " discounted"
                                          : " full-price"
                                      }`}>
                                        
                                         ${
                                           compareAtPrice === null
                                             ? html`
                                                <span
                                                  class="product-price-regular"
                                                  dangerouslySetInnerHTML=${{
                                                    __html:
                                                      helpers.formatCurrency(
                                                        price
                                                      ),
                                                  }}
                                                />
                            `
                                             : html`<span
                                                      class="product-price-regular"
                                                      dangerouslySetInnerHTML=${{
                                                        __html:
                                                          helpers.formatCurrency(
                                                            compareAtPrice
                                                          ),
                                                      }}                                              
                                                    />`
                                         }
                                         ${
                                           helpers.isProductOnSale(
                                             compareAtPrice,
                                             price
                                           )
                                             ? html`
                                            <span
                                              class="sale-price-text-color product-price-discounted"
                                              dangerouslySetInnerHTML=${{
                                                __html:
                                                  helpers.formatCurrency(price),
                                              }}
                                            />
                                            `
                                             : ""
                                         }
                                       
                                      </span>
                                    `
                                } ${
                                    helpers.isProductOnSale(compareAtPrice, price)
                                      ? html`
                                          <span class="product-per-off ${
                                            window.theme.showPerOffMobile
                                              ? "show-per-off-mobile"
                                              : ""
                                          }${
                                          window.theme.showPerOffDesktop
                                            ? " show-per-off-desktop"
                                            : ""
                                        }">
                                          (-${Math.round(
                                            ((compareAtPrice - price) * 100) /
                                              compareAtPrice
                                          )}%)
                                        </span>
                                      `
                                    : ""
                                   }
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                `;
              },
            },
          },
        },
      }
    : {};

  const noResultsOptions = window.theme.tagalysNoResultsWidgetId
    ? {
        includeTagalysCSS: false,
        widgets: [noResultWidgetObj],
      }
    : {};

  window.Tagalys.UIWidgets.SearchResults.init(".search-results-container", {
    templates: {
      widget: {
        labels: getTagalysLabels('searchResults'),
        options: {
          includeTagalysCSS: false,
          canAppendQueryStringToUrl: true,
          perPage: window.theme.tagalysSearchResultCount,
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;

          if (helpers.isInitialLoading()) {
            return html`
              <${args.templates.loader} />
            `;
          }

          var classes = ["plp", "search-results", "page-width"];
          if (helpers.isFilterDrawerOpen()) {
            classes.push("filter-drawer-opened");
          }

          if (helpers.isLoading()) {
            classes.push("loading");
          }

          if (helpers.canShowFiltersInDrawer()) {
            classes.push("show-filters-in-drawer");
          }

          var className = classes.join(" ");

          if (helpers.hasNoSearchResults() && !helpers.hasAnyFiltersApplied()) {
            return html`
              <div class="plp search-results results-tagalys">
                <${args.templates.noResults} />
              </div>
            `;
          }

          var currentPageItemCount =
            helpers.getCurrentPage() * window.theme.tagalysSearchResultCount -
            (window.theme.tagalysSearchResultCount - 1);
          var totalPageItemsCount =
            helpers.getCurrentPage() * window.theme.tagalysSearchResultCount;
          var totalSearchItemsCount =
            helpers.getTotalProductsCount() > 1
              ? `${helpers.getTotalProductsCount()} Results`
              : `${helpers.getTotalProductsCount()} Result`;

          if (
            helpers.getCurrentPage() == helpers.getTotalPages() &&
            helpers.getTotalProductsCount() < totalPageItemsCount
          ) {
            totalPageItemsCount = totalSearchItemsCount;
          }

          var searchResultCounterStr = html`Showing <span>${currentPageItemCount} - ${totalPageItemsCount}</span> of ${totalSearchItemsCount}`;
          var appliedFilters = helpers.getAppliedFilters(true);
          var showClearAllFiltersAction = appliedFilters.length;
          let previousPageLoad = '';
          if (helpers.canLoadPreviousResults() == true && helpers.getCurrentPage() > 1) {
            previousPageLoad = html`<${args.templates.loadPrevious} />`;
          }
          let viewType = localStorage.getItem("collectionViewType") || "view-4";
          searchFiltersSticky();
          return html`
              <div class=${className}>
                <${args.templates.header} />
                <div class="grid grid__uniform collection__container">
                  <div class="grid__item collection-sorting">
                    <div class="filter-main">
                      <div class="hide-filter">
                        ${window.tagalysIcon.hideFilter(html)}
                        <span>Hide Filter<span class="hide-filter-space">(${helpers.getTotalProductsCount()})</span></span>
                      </div>
                      <div class="show-filter" style="display:none;">
                        ${window.tagalysIcon.showFilter(html)}
                        <span>Show Filter<span class="hide-filter-space">(${helpers.getTotalProductsCount()})</span></span>
                      </div>
                    </div>
                    
                    <div class="collection__filters">
                      <div class="collection__filter-wrap ">
                        <div class="collection-sort-block">
                          <${args.templates.productListHeader} />
                        </div>
                        <div class="viewing-main">
                            <div class="viewing-type viewing-type-3 ${viewType == "view-3" ? "active" : ""}">
                              ${window.tagalysIcon.view3(html)}
                            </div>
                            <div class="viewing-type viewing-type-4 ${viewType == "view-4" ? "active" : ""}">
                              ${window.tagalysIcon.view4(html)}
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid__item small-down--one-whole medium-up--one-whole filter-wrapper" style="display:none;">
                    <div class="flex filters-action-block" style="display:none;">
                      <span class="result-counter">
                        ${
                          helpers.getTotalProductsCount() > 1
                            ? `${helpers.getTotalProductsCount()} Results`
                            : `${helpers.getTotalProductsCount()} Result`
                        }
                      </span>
                      <div id="toggle-tg-filter-v2" class="toggle-tg-filter">
                        ${window.tagalysIcon.toggleFilter(html)}
                        <span class="mobile-facets__open-label button-label">Filter </span>
                      </div>
                    </div>
                    
                  </div>
                 
                  <div class="collection-products-main">
                  <div class="medium-up--one-fifth grid__item collection_tg_filter-wrap ${helpers.canShowFiltersInDrawer() ? `` : `open`}">
                  <div class="collection_tg_filter_mobile_footer">
                      <div class="filter__label clear-all-filters">
                        <button type="button" class="clear-all-filters-btn" onclick=${() => {
                          helpers.clearAllFilters();
                          clearAllFilterDataLayerEvent(props);
                        }}>
                          ${
                            showClearAllFiltersAction > 0
                              ? html`
                            Clear`
                              : "Clear"
                          }
                        </button>
                      </div>
                      <div class="apply-filter-count" onClick=${
                        props.helpers.closeFilterDrawer
                      }>Apply<span class="mobile-totalCount">${
            helpers.getTotalProductsCount()
              ? "(" + helpers.getTotalProductsCount() + ")"
              : ""
          }</span></div>
                  </div>
                  <div class="collection_tg_filter_mobile_header">
                    <div>${helpers.getQuery()}</div>
                    <button type="button" class="close-filter filter-drawer-toggle" onClick=${
                      props.helpers.closeFilterDrawer
                    }>

                      ${window.tagalysIcon.close(html)}
                    </button>
                  </div>
                  <div class="mobile-appliedFilters collection__filter-actions">
                  <${args.templates.appliedFilters} />
        
                  </div>
                  <${args.templates.filters} />
                  </div>
                  <div class="collection__products grid__item medium-up--one-whole medium-up--four-fifths ${viewType == 'view-3' ? 'type-3' : ''}">
                      <div class="collection__filter-actions">
                        <${args.templates.appliedFilters} />
                      </div>
                      <div role="list" class="grid grid--flex display--grid">
                        ${previousPageLoad}
                        <${args.templates.products} />
                        <${args.templates.productListFooter} />
                      </div>
                      ${
                        helpers.isFilterDrawerOpen()
                          ? html`
                            <div class="filter-overlay" onclick=${helpers.closeFilterDrawer} />
                          `
                          : ""
                      }
                    </div>
                  </div>
                </div>
                <${args.templates.footer} />
              </div>
            `;
        },
      },
      noResults: {
        options: noResultsOptions,
        render: function (html, args) {
          return window.renderHelpers.noResults(html, args);
        },
      },
      header: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var filterOptions = helpers.getTemplateOptions("filters");
          return html`
            <div class="mobile-search-header-block">
              <div class="search-result-subheading">${args.labels.searchResults.heading.yourSearchResultsFor}</div>
              <div class="search-result-key">${helpers.getQuery()}</div>
            </div>
            <div class="plp-header">
              <div class="collection__tabs">
                <button type="button" id="toggle-tg-filter" class="collection__tab collection__tab--filter filter-drawer-toggle" onclick=${
                  helpers.openFilterDrawer
                }>
                  <span class="filter-drawer-btn open-filter-drawer" >
                    ${window.tagalysIcon.openFilter(html)}
                    Filter
                    ${window.renderHelpers.collectionResultsCount(html, args)}
                  </span>
                  <span class="filter-drawer-btn close-filter-drawer" onClick=${
                    props.helpers.closeFilterDrawer
                  }>
                    Filter
                    ${window.tagalysIcon.minus(html)}
                    ${window.renderHelpers.collectionResultsCount(html, args)}
                  </span>
                </button>
                <div class="collection__tab collection__tab--clear medium-up--hide">
                  <div class="clear-filters__container" style="display: none;">
                    <button type="reset" class="filter__label clear-filters__btn">
                      ${window.tagalysIcon.clearFilters(html)}
                      <span>${args.labels.filters.clearFilters}</span>
                    </button>
                  </div>
                </div>
                <div class="collection__tab collection__tab--grid medium-down--hide medium-up--one-sixth">
                  <div></div>
                </div>
                <div class="collection__tab collection__tab--sort medium-up--one-sixth">
                  <div class="collection__tab--sort-overlay">
                    <span>
                      ${args.labels.sortOptions.sortBy}
                      ${window.tagalysIcon.sortBy(html)}
                    </span>
                  </div>
                  ${
                    filterOptions.includeSortOptionsInFilters
                      ? ""
                      : html`
                        <${args.templates.sortOptions} />
                      `
                  }
                </div>
              </div>
            </div>
          `;
        },
      },
      productsPerPage: {
        render: function (html, args) {
          return window.renderHelpers.productsPerPage(html, args);
        },
      },
      productListHeader: {
        render: function (html, args) {
          return html`
            <${args.templates.infoAndActions} />
          `;
        },
      },
      infoAndActions: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var filterOptions = helpers.getTemplateOptions("filters");

          return html`
            <div class="collection__tab collection__tab--sort display-flex align-center justify-center">
              <span class="display-flex hide"
                >Filter
                ${window.renderHelpers.collectionResultsCount(html, args)}
              </span>
              ${
                filterOptions.includeSortOptionsInFilters
                  ? ""
                  : html`
                    <${args.templates.sortOptions} />
                  `
              }
            </div>
          `;
        },
      },
      sortOptions: {
        render: function (html, args) {
          return window.renderHelpers.sortOptions(html, args);
        },
      },
      products: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var products = helpers.getProducts();
          viewSearchResultsDataLayerEvent(
            helpers,
            ".search-results .product-card"
          );

          return html`
            ${products.map(
              (product, index) =>
                (product.images.length > 0)
                ? html`
                    <${args.templates.product} key=${index} product=${product} />
                  `
                : ''
            )}
          `;
        },
        callbacks: {
          // eslint-disable-next-line no-unused-vars
          afterInitialRender: function (helpers) {
            setTimeout(function () {
              window.renderHelpers.updateProductCards(".product-card");
            }, 2000);
          },
        },
      },
      productObj: {
        // Custom template to render variants
        render: function (html, args) {
          return window.renderHelpers.productObj(html, args)
        },
      },
      variantSelect: {
        render: function (html, args) {
          var product = args.props.product;
          var variants = product.variants;
          return html`
            <select name="id" class="no-js" aria-label="${args.labels.products.selectVariant}" data-product-select>
              ${variants.map((variant, i) => {
                return html`
                  <option ${
                    i === 0 ? 'selected="selected"' : ""
                  } data-i-${i} value="${variant.id}"
                    >${variant.title}</option
                  >
                `;
              })}
            </select>
          `;
        },
      },
      variantOption: {
        render: function (html, args) {
          var product = args.props.product;
          var variants = product.variants;
          return html`
              <div class="product-card__variant-picker product-card__variant-picker--with-options">
                ${window.renderHelpers.variantOption.header(html, args)}
                <div role="list" class="product-card__variants">
                  ${window.renderHelpers.variantOption.variantList(html, args)}
                  <div role="listitem" class="product-card__variant-container">
                    <button
                        type="button"
                        class="close-show-variants"
                        aria-label="${args.labels.products.closeVariants}"
                      >
                      ${window.tagalysIcon.closeShowVariants(html)}
                    </button>
                  </div>
                </div>
                <div role="list" class="product-card__mobile-variants">
                  ${window.renderHelpers.variantOption.variantListMobile(html, args)}
                </div>
              </div>
            `;
        },
      },
      addToCartForm: {
        render: function (html, args) {
          var product = args.props.product;
          var variants = product.variants;
          let {isOnlyInStore, isOnlyInStoreClass} = window.renderHelpers.getTags(product.tags)

          return html`
              <form action="${
                window.plp_vars.cart_add_url
              }" method="post" enctype="multipart/form-data" class="form">
                <input type="hidden" name="quantity" value="1" />
                <${args.templates.variantSelect} product=${product} />
                <${args.templates.variantOption} product=${product} />
                ${
                  variants.length > 1
                    ? html`
                      <button class="product__add--show-variants" type="button" aria-label="${args.labels.products.quickAdd}">
                        ${window.tagalysIcon.cart(html)}
                      </button>
                      <button
                        type="button"
                        class="product__add--mobile product__add--show-variants"
                        aria-label="${args.labels.products.quickAdd}"
                      >
                        ${window.tagalysIcon.cart(html)}
                      </button>
                    `
                    : html`
                      <button
                        class="product__add"
                        type="submit"
                        name="add"
                        data-add-to-cart=""
                        aria-label="${args.labels.products.quickAdd}"
                      >
                        ${window.tagalysIcon.cart(html)}
                      </button>
                      <button
                        class="product__add--mobile"
                        type="submit"
                        name="add"
                        data-add-to-cart=""
                        aria-label="${args.labels.products.quickAdd}"
                      >
                        ${window.tagalysIcon.shoppingBag(html)}
                        ${window.tagalysIcon.checkmark(html)}
                      </button>
                    `
                }
              </form>
            `;
        },
      },
      product: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var product = props.product;
          var fomoBadgeStyle = "";
          var promo_text = "";
          var promo_style = "";
          var promo_link = "";
          var promo_format_only = false;
          var productOptions = helpers.getTemplateOptions("product");
          var productLink = productOptions.productPageUrl(product);
          var navigateToProductDetailPage = (event) => {
            try {
              sessionStorage.setItem("tagalys_product_card_clicked", product.id);
            } catch (e) {
              console.log('Failed to save breadcrumb map to sessionStorage', e);
            }
            helpers.navigateToProductDetailPage(event, product);
          }
          const {price, compareAtPrice} = window.renderHelpers.getPrice(product)

          let badge = "", badgeStyles = "";
          let {isOnlyInStore, isOnlyInStoreClass, offer, offerProperty} = window.renderHelpers.getTags(product.tags)

          if (!badge) {
            var collections = product.collections;
            var collectionsMetaObject = window.theme.collectionMetaobjects;
            var tempbadge = false;
            // Quickview two badge
            var quickviewBadgeCounter = 0;
            var quickviewBadgeHtml = "";

            for (var i = 0; i < collectionsMetaObject.length; i++) {
              let badgeCollections = collectionsMetaObject[i].collections || [];
              if(badgeCollections.length > 0){
                for (var j = 0; j < collections.length; j++) {
                  let matchFound = badgeCollections.some(bc => String(bc.id) === String(collections[j].id));
                  if (matchFound) {
                    var quickviewbadgestyle = "";
                    var quickviewbadgeClass = "";
                    quickviewbadgestyle = `background-color:  ${collectionsMetaObject[i].badge_background_color}`;
                    quickviewbadgestyle = `${quickviewbadgestyle}; color:  ${collectionsMetaObject[i].badge_text_color};`;
                    if (collectionsMetaObject[i].badge_border_color) {
                      quickviewbadgestyle = `${quickviewbadgestyle}; border-color:${collectionsMetaObject[i].badge_border_color};`;
                    }
                    if (collectionsMetaObject[i].opacity) {
                      quickviewbadgestyle = `${quickviewbadgestyle}; opacity:${collectionsMetaObject[i].opacity};`;
                    }
                    if (collectionsMetaObject[i].fomo_style == true) {
                      quickviewbadgeClass = "fomo-badge";
                    } else if (collectionsMetaObject[i].default_style == true) {
                      quickviewbadgeClass = "default-badge";
                    }
                    quickviewBadgeHtml = html`${quickviewBadgeHtml}<div data-product-card-badge="9716480573767" data-badgestr="${collectionsMetaObject[i].badge_text}" class="product-card__badge ${quickviewbadgeClass}" style="${quickviewbadgestyle}">${collectionsMetaObject[i].badge_text}</div>`;
                    quickviewBadgeCounter++;
                    if (quickviewBadgeCounter >= 2) {
                      break;
                    }
                  }
                }
              }
            }
            for (var i = 0; i < collectionsMetaObject.length; i++) {
              for (var j = 0; j < collections.length; j++) {
                if (
                  collections[j].title ==
                  collectionsMetaObject[i].collection_name
                ) {
                  badge = collectionsMetaObject[i].badge_text;
                  badgeStyles = `background-color:  ${collectionsMetaObject[i].badge_background_color}`;
                  badgeStyles = `${badgeStyles}; color:  ${collectionsMetaObject[i].badge_text_color};`;
                  if (collectionsMetaObject[i].badge_border_color) {
                    badgeStyles = `${badgeStyles}; border-color:${collectionsMetaObject[i].badge_border_color};`;
                  }
                  if (collectionsMetaObject[i].opacity) {
                    badgeStyles = `${badgeStyles}; opacity:${collectionsMetaObject[i].opacity};`;
                  }
                  if (collectionsMetaObject[i].fomo_style == true) {
                    fomoBadgeStyle = "fomo-badge";
                  } else if (collectionsMetaObject[i].default_style == true) {
                    fomoBadgeStyle = "default-badge";
                  }
                  tempbadge = true;
                  break;
                }
              }
              if (tempbadge) {
                break;
              }
            }
          }
          // Promo Callout
          var collections = product.collections;
          var promo_callout_metaobject = window.theme.promo_callout_metaobject;
          // console.log("Metaobject", promo_callout_metaobject);
          var temppromo = false;
          for (var i = 0; i < promo_callout_metaobject.length; i++) {
            for (var j = 0; j < collections.length; j++) {
              if (collections[j].id == promo_callout_metaobject[i].id) {
                promo_text = promo_callout_metaobject[i].promo_text;
                // console.log("promo_text", promo_text);
                promo_style = `color:  ${promo_callout_metaobject[i].text_colour};`;
                promo_link = `/collections/${collections[j].handle}`;
                temppromo = true;
                break;
              }
            }
            if (temppromo) {
              break;
            }
          }

          // Multibuy offer badges
          var multibuy_offer_discounts = window.theme.multibuy_offer_discounts || [];
          const currentPageHandle = window.theme && window.theme.currentPageHandle
            ? String(window.theme.currentPageHandle)
            : (window.location.pathname.includes('/collections/')
              ? window.location.pathname.split('/collections/')[1].split('/')[0].split('?')[0]
              : '');

          for (var i = 0; i < multibuy_offer_discounts.length; i++) {
            const offer = multibuy_offer_discounts[i];
            const discount_type = offer.discount_type;
            const discount_key = offer.discount_key || '';
            const collection_handle = offer.collectionHandle || '';
            const collectionTitle = offer.collectionTitle || '';
            if (offer.active === false || offer.active === 'false') continue;
            if (!discount_key && !collection_handle) continue;

            let isMatch = false;

            if (discount_type === "collection" || !discount_type) {
              if (collection_handle && currentPageHandle && String(currentPageHandle) === String(collection_handle)) {
                isMatch = true;
              }
              if (!isMatch && discount_key && currentPageHandle && String(currentPageHandle) === String(discount_key)) {
                isMatch = true;
              }
              if (!isMatch && product.collections && Array.isArray(product.collections)) {
                isMatch = product.collections.some(function(c) {
                  if (!c) return false;
                  const cHandle = typeof c === 'object' && c !== null ? c.handle : (typeof c === 'string' ? c : null);
                  const cTitle = typeof c === 'object' && c !== null ? c.title : (typeof c === 'string' ? c : null);
                  const cId = typeof c === 'object' && c !== null ? c.id : (typeof c === 'number' || typeof c === 'string' ? c : null);

                  if (collection_handle && cHandle && String(cHandle) === String(collection_handle)) return true;
                  if (discount_key && ((cHandle && String(cHandle) === String(discount_key)) || (cTitle && String(cTitle) === String(discount_key)))) return true;
                  if (collectionTitle && cTitle && String(cTitle) === String(collectionTitle)) return true;
                  if (offer.id && cId && String(cId) === String(offer.id)) return true;
                  return false;
                });
              }
              if (!isMatch && product.tags && Array.isArray(product.tags)) {
                if (collection_handle && product.tags.includes(collection_handle)) isMatch = true;
                if (!isMatch && discount_key && product.tags.includes(discount_key)) isMatch = true;
              }
            }

            if (!isMatch && (discount_type === "tag" || !discount_type)) {
              if (product.tags && Array.isArray(product.tags)) {
                if (discount_key && product.tags.includes(discount_key)) isMatch = true;
                if (!isMatch && collection_handle && product.tags.includes(collection_handle)) isMatch = true;
              }
            }

            if (isMatch) {
              promo_text = offer.description || offer.title || "";
              promo_link = offer.collectionUrl || (collection_handle ? `/collections/${collection_handle}` : (discount_key ? `/collections/all/tagged/${discount_key}` : '#'));
              if (offer.color) {
                promo_style = `color: ${offer.color};`;
              }
              temppromo = true;
              promo_format_only = true;
              break;
            }
          }

          return html`
            <div class="grid__item medium-down--one-half large-up--one-whole product-card-wrapper">
              <div class="product-card product-card--quick" data-offer="${offerProperty}" data-sku="${
            product.variants[0].sku
          }">
                ${window.renderHelpers.productCard.wishlistButton(html, args)}
                <div class="product-card__image">
                  <div class="product-card__image--wrapper" onClick=${navigateToProductDetailPage}>
                    <a href="${productLink}" title="${product.title}">
                      ${window.renderHelpers.productCard.images(html, args)}
                    </a>
                  </div>
                  ${window.renderHelpers.productCard.actions(html, args, isOnlyInStoreClass)}
                </div>
                 ${
                   badge != ""
                     ? html`<div style="${badgeStyles}" class="product-card__badge ${fomoBadgeStyle}" data-product-card-badge="${product.id}" data-badgestr="${badge}">${badge}</div><div class="quickviewBadges" style="display:none;">${quickviewBadgeHtml}</div>`
                     : ""
                 }
                <div class="product-card__info">
                  <div class="product-card__details">
                    <div class="product-card__text">
                    ${
                      promo_text != ""
                        ? html`<a href="${promo_link}" style="${promo_style || ''}" class="promo_callout" data-text="${promo_text.replace(/\"|\'/g, '').replace(/\s/g, '')}" data-currency="${window.theme.currentCurrency}">
                                  ${window.tagalysIcon.plpPromoImage(html)}
                                  ${window.tagalysIcon.quickviewPromoImage(html)}
                                  <span>${theme.CurrencySwitcher.getCurrencyHTML(promo_text, html,promo_format_only)}</span>
                                  </a>`
                        : ""
                    }
                      <h4 class="product-card__title"  onClick=${navigateToProductDetailPage}>
                        <a href="${productLink}">
                          <span>${product.title}</span>
                        </a>
                      </h4>
                      <div class="product-card__price product-card--flex"  onClick=${navigateToProductDetailPage}>
                                ${
                                  helpers.isStorefrontAPICallPending()
                                    ? html`
                                      <span class="skeleton-box"></span>
                                    `
                                    : html`
                                      <span class=${`product-prices ${
                                        helpers.isProductOnSale(
                                          compareAtPrice,
                                          price
                                        )
                                          ? " discounted"
                                          : " full-price"
                                      }`}>
                                        
                                         ${
                                           compareAtPrice === null
                                             ? html`
                                              <span
                                                class="product-price-regular"
                                               dangerouslySetInnerHTML=${{
                                                 __html:
                                                   helpers.formatCurrency(
                                                     price
                                                   ),
                                               }}
                                              />
                                            `
                                             : html`  <span
                                              class="product-price-regular"
                                               dangerouslySetInnerHTML=${{
                                                 __html:
                                                   helpers.formatCurrency(
                                                     compareAtPrice
                                                   ),
                                               }}
                                              />`
                                         }
                                         ${
                                           helpers.isProductOnSale(
                                             compareAtPrice,
                                             price
                                           )
                                             ? html`
                                            <span
                                              class="sale-price-text-color product-price-discounted"
                                              dangerouslySetInnerHTML=${{
                                                __html:
                                                  helpers.formatCurrency(price),
                                              }}
                                              />
                                            `
                                             : ""
                                         }
                                       
                                      </span>
                                    `
                                } ${
                                helpers.isProductOnSale(compareAtPrice, price)
                                  ? html`
                                <span class="product-per-off ${
                                  window.theme.showPerOffMobile
                                    ? "show-per-off-mobile"
                                    : ""
                                }${
                                  window.theme.showPerOffDesktop
                                    ? " show-per-off-desktop"
                                    : ""
                                }">
                                  (-${Math.round(
                                    ((compareAtPrice - price) * 100) /
                                      compareAtPrice
                                  )}%)
                                </span>
                              `
                              : ""
                              }

                              </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `;
        },
      },
      filters: {
        options: {
          collapsible: true,
          includeSortOptionsInFilters: false,
          autoCollapse: true,
          showAppliedFilters: true,
          showClearAllFilters: true,
          showClearActionForIndividualFilters: true,
          showMatchingProductsCount: window.theme.tagalysShowFilterItemsCount,
          defaultExpandedFilters: [],
          expandTopNFiltersByDefault: 1,
          showFiltersInDrawer: () => {
            return window.innerWidth <= 768;
          },
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;

          var filters = helpers.getFilters();
          var appliedFilters = helpers.getAppliedFilters(true);
          var showClearAllFiltersAction =
            props.showClearAllFilters && appliedFilters.length;
          var classes = ["filters"];
          if (props.collapsible) {
            classes.push("collapsible");
          }

          var className = classes.join(" "); // eslint-disable-line no-unused-vars
          return html`

            <div class="collection-filters-block ">
              <${args.templates.filtersHeader} />

              ${
                props.includeSortOptionsInFilters === "top"
                  ? html`
                    <${args.templates.sortOptionInFilters} />
                  `
                  : ""
              }
              ${filters.map(
                (filter) =>
                  html`
                    <${args.templates.filter} filter=${filter} />
                  `
              )}
              ${
                props.includeSortOptionsInFilters === true ||
                props.includeSortOptionsInFilters === "bottom"
                  ? html`
                    <${args.templates.sortOptionInFilters} />
                  `
                  : ""
              }
            </div>
          `;
        },
        callbacks: {
          afterEveryRender: function (helpers) {
            window.renderHelpers.attachSearchListener(helpers)
            customTagalysActionEvents(helpers);
          },
        },
      },
      filtersHeader: {
        render: function (html, args) {
          var props = args.props; // eslint-disable-line no-unused-vars
          return html``;
        },
      },
      appliedFilters: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;

          var appliedFilters = helpers.getAppliedFilters(true);
          if (!appliedFilters.length) {
            return html``;
          }

          return html`
            <ul class="applied-filters unstyled-list">
              ${appliedFilters.map((appliedFilter) => {
                if (appliedFilter.type === "range") {
                  return html`
                    <li onClick=${() => {
                      helpers.clearFilter(appliedFilter.id);
                      removeFilterDataLayerEvent(props, appliedFilter.id);
                    }} class="applied-filter">
                        <span class="applied-filter-label"
                        dangerouslySetInnerHTML=${{
                          __html:
                            helpers.labelFormatter(
                            appliedFilter.display_format,
                            appliedFilter.selected_min,
                            appliedFilter.currency
                          )+'<span class="price-applied-space"> - </span>'+
                            helpers.labelFormatter(
                            appliedFilter.display_format,
                            appliedFilter.selected_max,
                            appliedFilter.currency
                          ),
                        }} />
                        <button class="applied-filter-action-clear">
                          ${window.tagalysIcon.closeIcon(html)}
                        </button>
                    </li>
                  `;
                }
                return appliedFilter.items.map((filterItem) => {
                  if (appliedFilter.id == "size") {
                    var filterItemName = filterItem.label.toUpperCase();
                  } else {
                    var filterItemName = filterItem.label.toLowerCase();
                  }
                  return html`
                    <li
                      class="display-flex applied-filter"
                      onClick=${() => {
                        helpers.clearFilter(appliedFilter.id, filterItem.id);
                        removeFilterDataLayerEvent(
                          props,
                          appliedFilter.id,
                          filterItem
                        );
                      }}
                    >
                      <span class="filter__label applied-filter-label">
                        ${filterItemName}
                      </span>
                      <span class="filter__label applied-filter-action-clear">
                        ${window.tagalysIcon.closeIcon(html)}
                      </span>
                    </li>
                  `;
                });
              })}
              <li class="applied-filter filter__label clear-all-filters">
                <button type="button" class="clear-all-filters-btn" onclick=${() => {
                  helpers.clearAllFilters();
                  clearAllFilterDataLayerEvent(props);
                }}>
                  <span class="filter__label applied-filter-label">${args.labels.filters.clearAllFilters}</span>
                </button>
              </li>
            </ul>
          `;
        },
      },
      filter: {
        render: function (html, args) {
          return window.renderHelpers.filter(html, args);
        },
      },
      filterHeader: {
        render: function (html, args) {
          return window.renderHelpers.filterHeader(html, args);
        },
      },
      filterItems: {
        render: function (html, args) {
          var props = args.props;
          if (props.filter.type === "checkbox") {
            return html`
                <div class="filter__list filter-body filter-body-checkboxes ${props.filter.id}">
                  <${args.templates.filterCheckBoxes} filterId=${props.filter.id} filterItems=${props.filter.items} />
                </div>
              `;
          }
          return html`
              <div class="filter__list filter-body filter-body-range">
                <${args.templates.rangeSliderFilterItem} filter=${props.filter} />
              </div>
            `;
        },
      },
      filterCheckBoxes: {
        render: function (html, args) {
          var props = args.props;
          return html`
            <ul class="filter-checkboxes">
              ${props.filterItems.map((filterItem) => {
                return html`
                <${args.templates.checkboxFilterItem}
                  filterId=${props.filterId}
                  filterItem=${filterItem}
                >
                ${
                  filterItem.selected && filterItem.items
                    ? html`
                        <${args.templates.filterCheckBoxes}
                          filterId=${props.filterId}
                          filterItems=${filterItem.items}
                        />
                      `
                    : ""
                }
              </${args.templates.checkboxFilterItem}>
            `;
              })}
            </ul>
          `;
        },
      },
      filterCheckBoxes: {
        render: function (html, args) {
          var props = args.props;
          var showLessHtml = "";
          return html`
              <ul class="filter-checkboxes">
                ${props.filterItems.map((filterItem, index) => {
                  var classname = "";
                  var showMoreHtml = "";

                  if (window.innerWidth < 768 && props.filterId == "colour") {
                    if (index == 18) {
                      var show_more_count = props.filterItems.length - 18;
                      classname = "expand";
                      showMoreHtml = html`<li class="show_more"><button class="show_more_color">${args.labels.ui.showMoreCount.replace('{{ count }}', show_more_count)}</button></li>`;
                      showLessHtml = html`<li class="show_less" style="display:none;"><button class="show_less_color">${args.labels.ui.showLess}</button></li>`;
                    }
                  } else {
                    if (index == 5) {
                      var show_more_count = props.filterItems.length - 5;
                      classname = "expand";
                      showMoreHtml = html`<li class="show_more"><button class="show_more_click">${args.labels.ui.showMoreCount.replace('{{ count }}', show_more_count)}</button></li>`;
                      showLessHtml = html`<li class="show_less" style="display:none;"><button class="show_less_click">${args.labels.ui.showLess}</button></li>`;
                    }
                  }
                  return html`
                 ${showMoreHtml}
                  <${args.templates.checkboxFilterItem}
                    filterId=${props.filterId}
                    filterItem=${filterItem}
                    index=${index}
                    class=${classname}
                  >
                  ${
                    filterItem.selected && filterItem.items
                      ? html`
                          <${args.templates.filterCheckBoxes}
                            filterId=${props.filterId}
                            filterItems=${filterItem.items}
                          />
                        `
                      : ""
                  }
                </${args.templates.checkboxFilterItem}>
              `;
                })}
                ${showLessHtml}
              </ul>
            `;
        },
      },
      checkboxFilterItem: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;

          const onFilterClick = (event) => {
            event.stopPropagation();
            if (props.filterItem.selected) {
              helpers.clearFilter(props.filterId, props.filterItem.id);
              removeFilterDataLayerEvent(
                props,
                props.filterId,
                props.filterItem
              );
            } else {
              helpers.applyFilter(props.filterId, props.filterItem.id);
              applyFilterDataLayerEvent(props);
            }
          };
          var icon = "";
          var code = "#1A1A1A";
          if (props.filterId == "colour") {
            var filterName = String(props.filterItem.label.trim()).toLowerCase();
            if (window.plp_vars.coloursMeta[filterName]) {
              if (window.plp_vars.coloursMeta[filterName].icon) {
                icon = window.plp_vars.coloursMeta[filterName].icon;
              } else if (window.plp_vars.coloursMeta[filterName].code) {
                code = window.plp_vars.coloursMeta[filterName].code;
              }
            }
          }
          var colour_icon = html`<span></span>`;
          if (props.filterId == "colour") {
            if (icon != "") {
              colour_icon = html`<span class="colour-icon"><img width="16" height="16" loading="lazy" src="${icon}" /></span>`;
            } else if (code != "") {
              colour_icon = html`<span class="colour-icon"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Colour">
                            <circle  cx="8" cy="8" r="8" fill="${code}"></circle>
                            </g>
                            </svg></span>`;
            }
          }

          return html`
              <li class="filter-item ${props.filterId}" data-filter-item-id=${
            props.filterItem.id
          } onClick=${onFilterClick}>
                <div class="filter__type filter-checkbox-and-label ${props.filterItem.label.toLowerCase()}">
                  ${colour_icon}
                  <input name="filter_${props.filterItem.id}" class="checkbox" checked=${
                    props.filterItem.selected
                  } type="checkbox" aria-label=${args.labels.filters.filterItem} />
                  <span class="filter-item-label-and-count">
                    <span class="filter-item-label">${props.filterItem.label.toLowerCase()}</span>
                    ${
                      props.showMatchingProductsCount
                        ? html`
                          <span class="filter-item-count">(${props.filterItem.count})</span>
                        `
                        : ""
                    }
                  </span>
                </div>
                ${props.children}
              </li>
            `;
        },
      },
      rangeSliderFilterItem: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          let {priceLabel, minPriceValue, maxPriceValue, priceValueLeft, priceValueRight, priceValueLeftClass, priceValueRightClass} = window.renderHelpers.rangeSliderFilterItem(html, args)

          return html`
              <div class="range-slider filter-item">
                <span class="max-range-info" style="display:none;">${priceLabel}</span>
                <div class="price-range-value" style="display:none;">
                  <span class="price-range__label--min-price ${priceValueLeftClass}" style="left: ${priceValueLeft};">
                    ${minPriceValue}
                  </span>
                  <span class="price-range__label--max-price ${priceValueRightClass}" style="right: ${priceValueRight};">
                    ${maxPriceValue}
                  </span>
                </div>

                <div></div>
                <div class="price-range__input-group">
                  <div class="min-price">
                  <span class="min-label">${args.labels.filters.min}</span>
                  <div class="price-range__input input-prefix input-container">
                    <span class="input-prefix__value">${
                      window.theme.currentCurrencySymbol
                    }</span>
                    <input
                      id="priceRangeMin"
                      type="number"
                      inputmode="numeric"
                      class="input-prefix__field field__input pr-input"
                      placeholder=${props.sliderInputValues[0]}
                      value=${props.sliderInputValues[0]}
                      onblur=${props.onInputBlur}
                      onchange=${props.onMinChange}
                      onfocus=${(this.value = "")}
                      aria-label=${args.labels.filters.priceRangeInput}
                    />
                    <label style="display:none;" for="priceRangeMin">
                      ${helpers.labelFormatter(
                        props.filter.display_format,
                        props.filter.min,
                        props.filter.currency
                      )}
                    </label>
                  </div>
                  </div>
                  <span class="to" style="display:none;">${
                    args.labels.filters.rangeFilterValueSeparator
                  }</span>
                   <div class="min-price">
                  <span class="min-label">${args.labels.filters.max}</span>
                  <div class="price-range__input input-prefix input-container">
                    <span class="input-prefix__value">${
                      window.theme.currentCurrencySymbol
                    }</span>
                    <input
                      id="priceRangeMax"
                      type="number"
                      inputmode="numeric"
                      class="input-prefix__field field__input pr-input"
                      placeholder=${props.sliderInputValues[1]}
                      value=${props.sliderInputValues[1]}
                      onblur=${props.onInputBlur}
                      onchange=${props.onMaxChange}
                    />
                    <label style="display:none;" for="priceRangeMax">
                      ${helpers.labelFormatter(
                        props.filter.display_format,
                        props.filter.max,
                        props.filter.currency
                      )}
                    </label>
                  </div>
                  </div>
                </div>
                <div ref=${props.sliderRef} />
              </div>
            `;
        },
      },
      sortOptionInFilters: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;

          var filterOptions = helpers.getTemplateOptions("filters");
          var appliedSortOption = helpers.getAppliedSortOption();
          var sortOptions = helpers.getSortOptions();

          let classes = ["filter"];
          let isCollapseOpen = false;
          if (filterOptions.collapsible) {
            isCollapseOpen =
              helpers.isCollapsibleFilterExpanded("sort_options");
            if (isCollapseOpen) {
              classes.push("is-expanded");
            } else {
              classes.push("collapsed");
            }
          }
          var className = classes.join(" ");

          return html`
            <div data-filter-id="sort_options" class=${className}>
              <${args.templates.filterHeader} filterHeading=${
                args.labels.sortOptions.sortBy
              } filterId=${"sort_options"} />
              <div class="filter-body filter-body-checkboxes">
                <ul class="filter-checkboxes">
                  ${sortOptions.map((sortOption) => {
                    const checked = sortOption.id === appliedSortOption.id;
                    return html`
                      <li
                        class="filter-item"
                        data-filter-item-id=${sortOption.id}
                        onClick=${() => {
                          helpers.applySortOption(sortOption.id);
                          clickSortOptionDataLayerEvent(helpers);
                        }}
                      >
                        <span class="filter-checkbox-and-label">
                          <input class="checkbox" checked=${checked} type="checkbox" />
                          <span class="filter-item-label-and-count">
                            <span class="filter-item-label">${
                              sortOption.label
                            }</span>
                          </span>
                        </span>
                      </li>
                    `;
                  })}
                </ul>
              </div>
            </div>
          `;
        },
      },
      pagination: {
        options: {
          infiniteScroll: true,
          trackPageNumbersForInfiniteScroll: true,
          showLoadNextAfterEvery: 1
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var plp_limit = window.theme.tagalysSearchResultCount;
         let shownProductsCount = plp_limit - 8;
          if (props.infiniteScroll) {
            searchFiltersSticky();
            if (helpers.isLoading()) {
              const productCards = document.querySelectorAll('.product-card-wrapper.last-products');
              if (productCards && productCards.length > 0) {
                productCards.forEach(card => {
                  card.style.removeProperty('display');
                  card.classList.remove('last-products')
                });
              }
              let placeholderCount = plp_limit;
              let placeholderHtml = [];

              for (var i = 0; i < placeholderCount; i++) {


                let _html = html`<div class="grid__item medium-down--one-half large-up--one-whole html2 placeholder-product-card">
                ${window.tagalysIcon.placeholderProductCard(html)}
                </div>`;
                if (window.innerWidth <= 989) {
                  _html = html`<div class="grid__item medium-down--one-half large-up--one-whole html2 placeholder-product-card">${window.tagalysIcon.placeholderProductCardSmall(html)}</div>`;
              }
                placeholderHtml.push(_html);
              }
              return html`${placeholderHtml}`;
            }
            else {
              let buttonHtml = html`<button class="load-next btn btn--primary" onclick=${props.helpers.loadNextPage
                }>
              ${helpers.isLoading()
                  ? args.labels.pagination.loading
                  : args.labels.pagination.loadNext
                }
            </button>`;
              
              if (!helpers.hasNextPage()) {
                buttonHtml = '';
              }
              if (!helpers.hasNextPage() && helpers.canLoadPreviousResults() == false) {
                shownProductsCount = helpers.getTotalProductsCount();
              }
              else {
                const productCards = document.querySelectorAll('.product-card-wrapper');
                if (productCards && productCards.length > 0) {
                  const lastProductCard = Array.from(productCards).slice(-8);
                  if (lastProductCard && lastProductCard.length > 0) {
                    lastProductCard.forEach(card => {
                      card.style.display = 'none';
                      card.classList.add('last-products');
                    });
                  }
                  shownProductsCount = productCards.length - 8;
                }
              }
              const percentage = Number(Math.min(100, Math.max(0, (shownProductsCount / helpers.getTotalProductsCount()) * 100)).toFixed(2));
              return html`<div class="infinite-scroll-content text-center m-b-xs">
           <div class="grid__item one-whole search-result-count">You've viewed ${shownProductsCount} of ${helpers.getTotalProductsCount()} products</div>
           <div class="progress-bar-container">
            <div class="progress-bar">
              <div class="load-more-progress-fill" style="width: ${percentage}%;"></div>
            </div>
          </div>${buttonHtml}
            </div>
          `;
            }
            // if (helpers.canLoadNextResults(props.showLoadNextAfterEvery)) {
            //   // return html`
            //   //         <${args.templates.loadNext} />
            //   //       `;
            // }
            // return "";
          }
          return html`
              <div class="grid__item one-whole collection__pagination pagination">
                <${args.templates.paginationLinks} />
              </div>
            `;
        },
      },
      loadPrevious: {
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          return html`<div class="previous-products-load-wrapper text-center m-b-xs">
        <button class="load-previous  btn btn--primary" onclick=${props.helpers.loadPreviousPage}>
          ${helpers.isLoading()
              ? args.labels.pagination.loading
              : args.labels.pagination.loadPrevious}
        </button>
        </div>
      `
        },
      },
      paginationLinks: {
        options: {
          showNumberedPageLinks: true,
          numberedPageLinksWindowSize: 3,
          showPreviousPageLink: true,
          showFirstPageLink: true,
          showNextPageLink: true,
          scrollTop: true,
        },
        render: function (html, args) {
          var props = args.props;
          var helpers = props.helpers;
          var pagesToDisplay = helpers.getPagesToDisplay(
            props.numberedPageLinksWindowSize
          );
          if (pagesToDisplay.length <= 1) {
            return;
          }
          var currentPage = helpers.getCurrentPage();
          var hasPreviousPage = helpers.hasPreviousPage();
          var hasNextPage = helpers.hasNextPage();

          var goToFirstPage = () => {
            helpers.goToPage(1);
          };

          return html`
            <ul class="ais-pagination">
              ${
                props.showFirstPageLink
                  ? html`
                    <li class="ais-pagination__item ais-pagination__item--first">
                      <button
                        class=${`ais-pagination__link${
                          currentPage === 1 ? " disabled" : ""
                        }`}
                        onclick=${currentPage === 1 ? undefined : goToFirstPage}
                      >
                        &lt;
                      </button>
                    </li>
                  `
                  : ""
              }
              ${
                props.showPreviousPageLink
                  ? html`
                    <li
                      class=${`ais-pagination__item ais-pagination__item--previous${
                        !hasPreviousPage
                          ? " ais-pagination__item--disabled"
                          : ""
                      }`}
                    >
                      <button
                        class=${`ais-pagination__link${
                          !hasPreviousPage ? " disabled" : ""
                        }`}
                        onclick=${
                          currentPage === 1
                            ? undefined
                            : helpers.goToPreviousPage
                        }
                      >
                        ${"<"}
                      </button>
                    </li>
                  `
                  : ""
              }
              ${
                props.showNumberedPageLinks
                  ? pagesToDisplay.map((pageDetail) => {
                      var classes = ["ais-pagination__item"];
                      var showEllipsis = pageDetail.jumpAfter;
                      if (pageDetail.current) {
                        classes.push("ais-pagination__item--active");
                      }
                      if (pageDetail.jumpAfter) {
                        classes.push("page-jump-over");
                      }
                      var className = classes.join(" ");
                      if (pageDetail.page == helpers.getTotalPages()) {
                        return html``;
                      }

                      return html`
                      <li class=${`${className}`}>
                        <button
                          class="ais-pagination__link"
                          onclick="${() => {
                            !showEllipsis && helpers.goToPage(pageDetail.page);
                          }}"
                        >
                          ${showEllipsis ? "..." : pageDetail.page}
                        </button>
                      </li>
                    `;
                    })
                  : ""
              }
              ${
                props.showNextPageLink
                  ? html`
                  ${
                    helpers.getCurrentPage() != helpers.getTotalPages()
                      ? html`
                      <li class="ais-pagination__item">
                        <button class="ais-pagination__link" onclick="${() => {
                          helpers.goToPage(helpers.getTotalPages());
                        }}">
                          ${helpers.getTotalPages()}
                        </button>
                      </li>`
                      : html`
                      <li class="ais-pagination__item ais-pagination__item--active">
                        <button
                          class="ais-pagination__link"
                          onclick="${() => {
                            helpers.goToPage(helpers.getTotalPages());
                          }}"
                        >
                          ${helpers.getTotalPages()}
                        </button>
                      </li>`
                  }
                  <li class=${`ais-pagination__item ais-pagination__item--next${
                    !hasNextPage ? " ais-pagination__item--disabled" : ""
                  }`}>
                    <button
                      class=${`ais-pagination__link${
                        !hasNextPage ? " disabled" : ""
                      }`}
                      onclick=${hasNextPage ? helpers.goToNextPage : undefined}
                    >
                      ${">"}
                    </button>
                  </li>`
                  : ""
              }
            </ul>
          `;
        },
      },
      downArrow: {
        // eslint-disable-next-line no-unused-vars
        render: function (html, args) {
          return html`
            ${window.tagalysIcon.chevron.down(html)}
            ${window.tagalysIcon.chevron.up(html)}
          `;
        },
      },
    },
    callbacks: {
      onSuccessfulAPICall: function (response, helpers) {
        const topSearchInput = document.querySelector(".search__input");
        const bodySearchInput = document.querySelector("#search-input");
        if (typeof helpers.getQuery() !== "undefined") {
          if (topSearchInput) {
            topSearchInput.value = helpers.getQuery();
          }
        }
        if (bodySearchInput) {
          bodySearchInput.addEventListener("focus", function () {
            document.querySelector(".header__btn--search").click();
          });
        }

        const elementToObserve = document.querySelector(
          ".tagalys-search-suggestions"
        );

        const searchWrapper = document.querySelector("#search--app");
        if( searchWrapper && elementToObserve ) searchWrapper.appendChild(elementToObserve)


        const observer = new MutationObserver(() => {
          const searchContainer = document.querySelector(
            ".search-results-container"
          );
          if (elementToObserve.hasChildNodes()) {
            searchContainer.classList.add("search-active");
          } else {
            searchContainer.classList.remove("search-active");
          }
        });
        observer.observe(elementToObserve, {
          subtree: true,
          childList: true,
        });

        $(document).on("focus", ".pr-input", function () {
          this.value = "";
        });

        window.renderHelpers.hideOpenedVariants();

        setTimeout(function () {
          window.renderHelpers.updateProductCards(".product-card");
        }, 2000);

        setTimeout(function () {
          window.renderHelpers.checkStickyElements(".product-card");
        }, 1000);
        return response;
      },
    },
  });
};

function whenTagalysStatisticsReady(fn) {
  if (window.theme.consentGating && window.lovisaConsent) {
    window.lovisaConsent.onConsentReady(function () {
      if (window.lovisaConsent.hasStatistics()) fn();
    });
    window.addEventListener("lovisa:consent-updated", function () {
      if (window.lovisaConsent.hasStatistics()) fn();
    });
  } else {
    fn();
  }
}

onTagalysReady(function () {
  if (window.theme.searchProvider == "tagalys") {
    if (window.theme.template.name === "search") {
      TagalysCustomisations.initTagalysSearchResults();
      setTimeout(cleanTagalysRecentSearches, 1000);
    }

    whenTagalysStatisticsReady(function () {
      TagalysCustomisations.initTagalysSearchSuggestions();
    });
  }
});

function searchFiltersSticky() {
  if (window.innerWidth > 768) {
    setTimeout(function () {
      var headerHight = typeof theme.getStickyHeaderHeight === 'function'
        ? theme.getStickyHeaderHeight()
        : 0;
      if (headerHight < 100) {
        headerHight = 114;
      }
      if (window.theme._sb_headerSection) {
        window.theme._sb_headerSection.update();
      }
      if (window.theme._sb_collectionSorting) {
        window.theme._sb_collectionSorting.update();
      }
      if (window.theme._sb_collectionFiltersBlock) {
        window.theme._sb_collectionFiltersBlock.update();
      }
      if (window.theme._sb_collectionFiltersActions) {
        window.theme._sb_collectionFiltersActions.update();
      }
    }, 1000);
  } else {
    setTimeout(function () {
      if (window.theme._sb_collectionFiltersActions) {
        window.theme._sb_collectionFiltersActions.update();
      }
    }, 1000);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var lastId = sessionStorage.getItem("tagalys_product_card_clicked");
  
  if(lastId){
    var productFindInterval = setInterval(function(){
      var productCard = document.querySelector(`.product-card[data-sku="${lastId}"]`);
      if (productCard) {
          productCard.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        sessionStorage.removeItem("tagalys_product_card_clicked");
        clearInterval(productFindInterval);
      }
    },100);
  }
});